import { render, staticRenderFns } from "./LukonTermination.vue?vue&type=template&id=27c5ee70&scoped=true&"
import script from "./LukonTermination.vue?vue&type=script&lang=js&"
export * from "./LukonTermination.vue?vue&type=script&lang=js&"
import style0 from "./LukonTermination.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./LukonTermination.vue?vue&type=style&index=1&id=27c5ee70&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "27c5ee70",
  null
  
)

export default component.exports